import FsLogger from '@fubei/web-logger'
import store from '@/store/index'
import { LOGGER_HOST, TRACKER_PROJECT, TRACKER_LOGSTORE } from '@/config/constants'
const NODE_ENV = process.env.VUE_APP_MODE || 'development'
const logger = new FsLogger({
  host: LOGGER_HOST, // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: TRACKER_PROJECT, // Project名称
  logstore: TRACKER_LOGSTORE, // Logstore名称
  data () {
    return {
      AppId: `fubeiapp-h5-project-${NODE_ENV}`,
      ...getCustomReport()
    }
  }
})

/**
 * @function 获取自定义上报对象
 */
function getCustomReport () {
  let { storeId, storeName } = store.state.teachAssistant.assistantStoreInfo
  if (!storeId) {
    storeId = localStorage.getItem('storeId')
  }
  return {
    User: sessionStorage.getItem('uid') || '',
    Store: `${storeId || ''}${storeId && storeName ? ',' : ''}${storeName || ''}`,
    RoleType: sessionStorage.getItem('roleType') || '',
    AccessToken: store.getters.accessToken || localStorage.getItem('access_token') || '',
    ClientSession: localStorage.getItem('ClientSession') || '' // 每次启动生成一个唯一ID，表示当前启动后的日志
  }
}

export default logger
